<template>
    <v-app>
        <router-view />
        <app-modal />
    </v-app>
</template>

<script>
import { loadScript } from "vue-plugin-load-script";
import { mapActions } from 'vuex'

export default {
    mounted() {
        // Load Gtag
        loadScript(`https://www.googletagmanager.com/gtag/js?id=${process.env.VUE_APP_GTAG_ID}`)
        .then(() => {
            window.dataLayer = window.dataLayer || [];
            // eslint-disable-next-line prefer-rest-params
            function gtag(){window.dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', process.env.VUE_APP_GTAG_ID);
        })
        .catch(() => {
            // Failed to fetch script
            console.log('Unable to load Gtag')
        });
        loadScript("./plugins/timeme.min.js")
        .then(() => {
            console.log('Timeme is working')
        })
        .catch(() => {
            // Failed to fetch script
            console.log('Unable to load TimeMe.js')
        });

        // Configurar detección inicial y listener para resize
        this.updateIsMobile()
        window.addEventListener('resize', this.handleResize)
    },
    beforeDestroy() {
        // Limpiar el listener cuando el componente se destruye
        window.removeEventListener('resize', this.handleResize)
    },
    methods: {
        ...mapActions(['setIsMobile']),
        validateIsMobile() {
            return window.innerWidth < 600
        },
        updateIsMobile() {
            const isMobile = this.validateIsMobile()
            this.setIsMobile(isMobile)
        },
        handleResize() {
            // Usar debounce para evitar demasiadas actualizaciones
            clearTimeout(this.resizeTimeout)
            this.resizeTimeout = setTimeout(() => {
                this.updateIsMobile()
            }, 100)
        }
    },
    data() {
        return {
            resizeTimeout: null
        }
    }
}
</script>

<style lang="scss">
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

#nav {
    padding: 30px;

    a {
        font-weight: bold;
        color: #2c3e50;

        &.router-link-exact-active {
            color: #42b983;
        }
    }
}
</style>
